import React, { FunctionComponent } from "react";
import { PostSnippet } from "../../types";
import { PageHeader } from "../pageHeader";
import { PostGrid } from "../postCard";
import { Pagination } from "../pagination";

export interface BlogList {
  page: number;
  hasNext: boolean;
  posts: PostSnippet[];
}

export const BlogList: FunctionComponent<BlogList> = ({
  page,
  posts,
  hasNext,
}) => {
  const prev = page > 1 ? `/page/${page - 1}/` : undefined;
  const next = hasNext ? `/page/${page + 1}/` : undefined;
  return (
    <>
      <PageHeader title={`Page ${page}`} />
      <div className="flex flex-col gap-14 px-gutter-sm pb-14 md:px-gutter">
        <PostGrid posts={posts} />
        <Pagination prev={prev} next={next} />
      </div>
    </>
  );
};
